import React from 'react';
import { CatalogReplacementSearch } from '@/components/catalog-replacement-search';
import { ChooseSubstitutionButton } from './choose-substitution-button';
import { ItemListOption } from '@/contexts/item-context-types';
import { useItemDetailContext } from '@/contexts/item-detail-context';

interface Props {
  availabilityFulfillmentDate: string;
  onSelect: (
    itemListOption: ItemListOption,
    substitutionAvailability: number | undefined,
  ) => void;
  variantPacksInOrder: Set<string>;
}

export const SearchSubstitutionsContent: React.FC<Props> = ({
  availabilityFulfillmentDate,
  onSelect,
  variantPacksInOrder,
}) => {
  const { closeDetailSheet } = useItemDetailContext();

  return (
    <CatalogReplacementSearch
      filterTrackingKey="search_substitution_content.item_group_selector"
      renderActions={(sku, source, { availabilityMap }) => (
        <ChooseSubstitutionButton
          alreadyInOrder={variantPacksInOrder.has(sku.variantPackUUID)}
          onSelect={(itemListOption) => {
            onSelect(
              itemListOption,
              availabilityMap[itemListOption.metadata!.variantPackUUID],
            );
            if (source === 'sheet') {
              closeDetailSheet();
            }
          }}
          sku={sku}
        />
      )}
      searchParams={{
        availabilityFulfillmentDate,
        searchSource: 'substitutions_screen',
      }}
    />
  );
};
